import React, { useState, useEffect } from 'react'

import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	MenuItem,
	TextField,
	Typography
} from '@material-ui/core'

import { makeStyles, confirmActivation } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	fieldWrapper: {
		'& .MuiTextField-root': { minWidth: '378px' }
	},
	summaryHeader: {
		fontSize: '12px',
		color: '#1A1A35',
		fontWeight: '800',
		opacity: '.75'
	},
	text: {
		color: '#1A1A35',
		fontSize: '14px'
	}
}))

const EditMembershipDialog = (props) => {
	const classes = useStyles()
	let { isShown, setIsShown, updateMembership } = props
	const [Membership, setMembership] = useState(props.membership)

	useEffect(() => {
		setMembership(props.membership)
	}, [props.membership])

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '500px',
					maxWidth: '500px',
					width: '500px',
					height: '225px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24
				}}>
				EDIT STATUS
			</DialogTitle>
			<DialogContent>
				<TextField
					variant="filled"
					select
					value={Membership && Membership.deactivated ? 'Ended' : 'Active'}
					label="Membership Status"
					onChange={(e) => {
						let value
						if (e.target.value == 'Ended') value = true
						if (e.target.value == 'Active') value = false
						setMembership({ ...Membership, deactivated: value })
					}}>
					{['Active', 'Ended'].map((option) => (
						<MenuItem key={option} value={option}>
							{option}
						</MenuItem>
					))}
					: null}
				</TextField>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					onClick={() => {
						updateMembership(Membership)
						setIsShown(false)
					}}
					color="secondary">
					Save
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default EditMembershipDialog
